/**
 * Format exchange and exchangeType for display.
 */
export function formatExchangeDisplay(
  exchange: string,
  exchangeType: string | null
): string {
  const formattedExchange =
    exchange && exchange.length > 0
      ? exchange.charAt(0).toUpperCase() + exchange.slice(1).toLowerCase()
      : "";

  const type = exchangeType || "spot";
  const formattedType = type
    .split("-")
    .map((word) =>
      word.length > 0
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : ""
    )
    .filter(Boolean)
    .join(" ");

  return formattedType
    ? `${formattedExchange} ${formattedType}`
    : formattedExchange;
}
